var map = {
	"./frame_1.png": 8620,
	"./frame_10.png": 4805,
	"./frame_11.png": 1694,
	"./frame_2.png": 8876,
	"./frame_3.png": 8344,
	"./frame_4.png": 2479,
	"./frame_5.png": 6859,
	"./frame_6.png": 7846,
	"./frame_7.png": 8004,
	"./frame_8.png": 7978,
	"./frame_9.png": 5825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6761;